<template>
  <div> 
    <approve-condition @search="handleSearch" :type="type"></approve-condition>
    <cu-table :data="list" :pageData="pageCondition" @currentChange="currentChange" :isLoading="isLoading" class="b-custom-table-only-condition">
      <el-table-column label="客户" min-width='130' fixed="left">
        <template slot-scope="scope">
          <span class="b-c-ellipse b-c-cursor" :title="scope.row.customer_name" @click="handleToCustomeDetail(scope.row.customer_id)">{{scope.row.customer_name || '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="审批状态" min-width="110">
        <template slot-scope="scope">
         <i class="approve-round" :class="`approve-round-${scope.row.check_status}`"></i>
          {{scope.row.check_status_name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="项目" min-width='150'>
        <template slot-scope="scope">
          <p class="b-c-ellipse" :title="scope.row.project_name">{{scope.row.project_name	 || '--'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="预约看房时间" min-width="150">
        <template slot-scope="scope">
          <p v-analysis-time:all="scope.row.voucher_appointment_time"></p>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" min-width="150">
        <template slot-scope="scope">
          <p v-analysis-time:all="scope.row.apply_time"></p>
        </template>
      </el-table-column>
      <el-table-column label="申请人" min-width='120'>
        <template slot-scope="scope">
          <p class="b-c-ellipse" :title="scope.row.admin_name">{{scope.row.admin_name || '--'}}</p>
        </template>
      </el-table-column>
      <template v-if="type === 'approveMine'">
        <el-table-column label="处理状态" min-width='110'>
          <template slot-scope="scope">
            <p class="b-c-ellipse" :title="scope.row.pending_status_name">{{scope.row.pending_status_name	 || '--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="处理人" min-width='120'>
          <template slot-scope="scope">
            <p class="b-c-ellipse" :title="scope.row.pending_handler_name">{{scope.row.pending_handler_name || '--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="处理时间" min-width="150">
          <template slot-scope="scope">
            <span v-analysis-time:all="scope.row.pending_handle_time"></span>
          </template>
        </el-table-column>
      </template>
      <el-table-column label="最后审批时间" min-width="150">
        <template slot-scope="scope">
          <span v-analysis-time:all="scope.row.approval_time"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="145" fixed="right">
        <template slot-scope="scope" >
          <div class="table-operation">
            <a class="ope-item" @click="handleToDetail(scope.row, 'approveReport')">详情</a>
            <a class="ope-item" @click="handleToEdit(scope.row, 'report')" v-if="(type === 'submitMine' || (type === 'all' && currentInfo.id === scope.row.admin_id)) && scope.row.check_status === 1">编辑</a>
            <a class="ope-item" @click="passPress(scope.row)" v-if="type === 'approveMine' && scope.row.pending_status === 1">通过</a>
            <a class="ope-item" @click="handleRefuse(scope.row)" v-if="type === 'approveMine' && scope.row.pending_status === 1">拒绝</a>
          </div>
        </template>
      </el-table-column>
    </cu-table>
    <!-- 拒绝原因 -->
    <approve-refuse-modal v-model="isRefuse" @confirm="handleRefuseEvent" />
  </div>
</template>
<script>
import {getReportApproList, getReportDealList} from '@/api/approve';
import CuTable from '@/components/cTable';
import ApproveRefuseModal from '@/components/refuseModal';
import ApproveCondition from '../component/condition';
import approveMixins from '../mixins/approve';
export default {
  name: 'ApproveReportList',
  mixins: [approveMixins],
  components: {
    ApproveCondition,
    CuTable,
    ApproveRefuseModal
  },
  async created () {
    this.initList();
  },
  methods: {
    // 初始化列表
    async initList (condition = {}) {
      this.isLoading = true;
      try {
        const params = {
          ...condition,
          ...this.pageCondition
        };
        if (this.type === 'all') params.option = 0;
        else if (this.type === 'submitMine') params.option = 1;
        
        const res = await (this.type === 'approveMine' ? getReportDealList : getReportApproList)(params);
        this.list = res.data || [];
        this.$set(this.pageCondition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '获取列表出现错误');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/base/condition.less');
</style>